import * as actionTypes from 'actions';

const initialState = {
  userProfile: {}
};

const userProfileReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SESSION_LOGIN: {
      return {
        ...initialState,
        userProfile: action.payload,
      };
    }
    default: {
      return state;
    }
  }
};

export default userProfileReducer;
